import { z } from 'zod'

const PHONE_MIN_DIGITS = 10
const PHONE_ALLOWED_PATTERN = /^[+\d\s().-]+$/

export function isValidOptionalPhone(value: string | null | undefined): boolean {
  const phone = value?.trim()
  if (!phone) return true

  const digitCount = phone.replace(/\D/g, '').length
  return digitCount >= PHONE_MIN_DIGITS && PHONE_ALLOWED_PATTERN.test(phone)
}

export const optionalPhoneSchema = z
  .string()
  .trim()
  .refine(isValidOptionalPhone, 'common.invalidPhone')
